import React from "react";
import { Grid } from "@mui/material";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";

export function TabIndicacionFields({
  firstRowfields,
  secondRowfields,
  thirdRowfields,
  formValues,
  handleChange,
  children
}) {

  return (
    <>
      <Grid container spacing={3}>
        {firstRowfields.map((input, index) => (
 <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== "item" ? 12 : 0 }}>
            <RenderInputByTypeMobile
              key={`input-${input.name}-index-${index}`}
              input={input}
              handleChange={handleChange}
              value={formValues[input.name]}
            />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3}>
        {secondRowfields.map((input, index) => (
 <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== "item" ? 12 : 0 }}>
            <RenderInputByTypeMobile
              key={`input-${input.name}-index-${index}`}
              input={input}
              handleChange={handleChange}
              value={formValues[input.name]}              
            />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3}>
        {thirdRowfields.map((input, index) => (
 <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== "item" ? 12 : 0 }}>
            <RenderInputByTypeMobile
              key={`input-${input.name}-index-${index}`}
              input={input}
              handleChange={handleChange}
              value={formValues[input.name]}
            />
          </Grid>
        ))}
        {children}
      </Grid>
    </>
  );
}